<div>
  <om-navbar-header [showLoginLink]="false" [showProgressBar]="false" (back)="onBack()"></om-navbar-header>
  <div class="container">
    <div class="row col-12 col-md-8 mt-5 mx-auto justify-content-center">
      <h1 class="text-center text-start">Edit your information</h1>
      <form [formGroup]="formGroup" class="mt-2" style="max-width: 400px">
        <div class="row flex-column align-items-center" style="gap: 16px">
          <ng-container *ngIf="isAddressEditable">
            <om-address-input data-cy="address-input" [address]="inlineForm"></om-address-input>
          </ng-container>
          <div class="col">
            <label [for]="formPreferredControlName" class="form-label font-weight-bold">
              <strong>Preferred First Name</strong>
            </label>
            <input
              type="text"
              class="form-control"
              [formControlName]="formPreferredControlName"
              [id]="formPreferredControlName"
              placeholder="Add your preferred first name"
              data-cy="preferred-name-field"
            />
          </div>
          <div class="col">
            <label [for]="formPronounsControlName" class="form-label font-weight-bold"><strong>Pronouns</strong></label>
            <om-dropdown
              [menuStyles]="{ width: '100%', textAlign: 'left', borderColor: '#ced4da', fontWeight: 400 }"
              [formControlName]="formPronounsControlName"
              [allValues]="['He/Him', 'She/Her', 'They/Them']"
              [id]="formPronounsControlName"
              placeholder="Select your pronouns"
              [arrowRight]="true"
              data-cy="pronouns-field"
            ></om-dropdown>
          </div>
          <div class="col">
            <label [for]="formGenderInfoControlName" class="form-label">
              <strong>Gender Info</strong>
            </label>
            <input
              type="text"
              class="form-control"
              [id]="formGenderInfoControlName"
              [formControlName]="formGenderInfoControlName"
              placeholder="Add your gender info"
              data-cy="gender-info-field"
            />
          </div>
        </div>
        <div class="mt-5">
          <omgui-button
            class="d-block"
            type="submit"
            size="fill-parent"
            (buttonClick)="validateAndSubmit($event)"
            [disabled]="isLoading || (isAddressEditable && !inlineForm.valid) || !formGroup.valid"
            data-cy="submit"
          >
            <div class="d-flex gap-2 justify-content-center align-items-center">
              <span>Update</span>
            </div>
          </omgui-button>
        </div>
      </form>
    </div>
  </div>
</div>
